import styled from 'styled-components';

export const StyledRow = styled.div`
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
`;

export const StyledContainer = styled.div`
  padding: 12px 35px;
  margin: 0;
  width: 15%;
  overflow: hidden;
  transition: width 0.35s ease-in-out;

  &.full-width {
    width: 100%;
  }
  &.half-width {
    width: 45%;
  }

  &.hidden {
    visibility: hidden;
  }
`;

export const StyledHeader = styled.h4`
  font-size: 1.1em;
  margin: 0 20px;
  padding: 5px 0;
`;

export const StyledRowHeader = styled.span`
  display: flex;
  flex: 1;

  > * {
    margin-right: 1em;
  }

  p {
    margin: auto 0;
  }
`;

export const StyledList = styled.ul`
  list-style: none;
  margin-top: 5px;
  padding: 0;
`;

export const StyledItem = styled.li`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #f0f0f0;
  padding: 5px 20px;
  position: relative;

  &.highlighted {
    background: #d3efeb;
  }

  .icon {
    height: 2.2em;
    width: 2.2em;
    vertical-align: middle;
    color: green;
    margin-right: 5px;
  }
`;

export const StyledListContainer = styled.div`
  max-height: 250px;
  overflow: auto;
  margin-left: -5px;
`;

export const StyledOrderedList = styled.ol`
  padding: 0;
  margin: 0 0 0 10px;
  font-size: 0.9em;
  color: #222;
  counter-reset: counter;
  list-style: none;
`;

export const StyledOItem = styled.li`
  padding: 8px 15px;
  counter-increment: counter;
  position: relative;

  &::before {
    content: counter(counter);
    color: #67a1b8;
    font-weight: bold;
    position: absolute;
    left: -10px;
    font-size: 1.1em;
  }
`;
